
// // const MTK = window.MTK;
// let mtkMapInstance = null;

// /**
//  * @param {HTMLElement} container
//  * @param {[number, number]} center
//  * @param {number} zoom
//  */
// export function initMTKMap(container, center, zoom) {
//   const MTK = window.MTK;
//   if (!MTK) {
//     console.error("MTK not available");
//     return;
//   }

//   if (mtkMapInstance) return;

//   // MTK.init({ api_key: "93563e3c-84df-435d-a44e-7a6c24e0d817" });
//   MTK.init({ api_key: process.env.VUE_APP_MTK_API_KEY });

//   MTK.createMap(
//     container,
//     {
//       map: {
//         mapType: "toursprung-terrain",
//         location: { center, zoom, pitch: 0, bearing: 0 },
//         controls: [
//           [new MTK.Map3DControl({ showCompass: 1, showPitch: 1 }), "bottom-right"],
//           [new MTK.StyleControl(["Winter"]), "top-right"],
//           [new MTK.WeatherControl({ mode: "null" }), "top-right"],
//         ],
//       },
//     },
//     (map) => {
//       mtkMapInstance = map;

//       console.log(" MTK 3D map loaded");
//       map.enableTerrain();

//       window.mtkMap = map;

//       const container = document.getElementById("weather-map-container");
//       if (container) {
//         container.style.background = "linear-gradient(to bottom, #a3d8fd 0%, #b0e2ff 10%, #f0f8ff 15%)";
//       }
//       const poiLayersToHide = [
//         "poi_label_bank",
//         "poi_label_peaks",
//         "poi_label_alpine_hut",
//         "poi_label_garden",
//         "poi_label_pitch",
//         "poi_toilet",
//         "poi_generator",
//         "poi_label_rail_station",
//         "poi_label_aerialway_station_icon",
//         "poi_label_subway_label",
//         "poi_label_3",
//         "poi_label_2",
//         "poi_label_1",
//         "poi_label_mountain_pass",
//       ];

//       // const logVisibleLayers = () => {
//       //   const style = map.gl.getStyle();
//       //   if (!style?.layers) return;

//       //   const visibleLayers = style.layers.filter(
//       //     (l) => l.layout?.visibility !== "none"
//       //   );

//       //   visibleLayers.forEach((layer, idx) => {
//       //     console.log(`${idx}: ${layer.id} | type: ${layer.type}`);
//       //   });
//       // };

//       const hidePOILayers = () => {
//         const style = map.gl.getStyle();
//         if (!style?.layers) return;

//         const hidden = [];

//         style.layers.forEach((layer) => {
//           if (
//             poiLayersToHide.includes(layer.id) &&
//             layer.layout?.visibility !== "none"
//           ) {
//             map.gl.setLayoutProperty(layer.id, "visibility", "none");
//             hidden.push(layer.id);
//           }
//         });
//       };


//       // map.once("idle", () => {
//       //   logVisibleLayers();
//       //   hidePOILayers();
//       // });


//       map.gl.on("styledata", () => {
//         hidePOILayers();
//       });
//       //        map.gl.on("moveend", () => {
//       //   const gl = map.gl;

//       //   const center = gl.getCenter(); // [lng, lat]
//       //   const zoom = gl.getZoom();
//       //   const pitch = gl.getPitch();
//       //   const bearing = gl.getBearing();

//       //   // Log detaliat
//       //   console.log(
//       //     "[MTK moveend]",
//       //     "zoom=", zoom.toFixed(2),
//       //     "| lat=", center.lat.toFixed(6),
//       //     "| lon=", center.lng.toFixed(6),
//       //     "| pitch=", pitch.toFixed(1),
//       //     "| bearing=", bearing.toFixed(1)
//       //   );
//       // });


//       map.gl.on("move", () => {
//         const pitch = map.gl.getPitch();
//         const container = document.getElementById("weather-map-container");
//         if (!container) return;
//         let gradient;

//         if (pitch >= 86) {
//           gradient = "linear-gradient(to bottom, #a3d8fd 0%, #b0e2ff 30%, #f0f8ff 40%)";
//         } else if (pitch >= 77) {
//           gradient = "linear-gradient(to bottom, #a3d8fd 0%, #b0e2ff 20%, #f0f8ff 30%)";
//         } else {
//           gradient = "linear-gradient(to bottom, #d6f0ff 0%, #b0e2ff 70%, #f0f8ff  50%)";
//         }
//         container.style.background = gradient;

//       });

//     }
//   );
// }


// export function getMTKMap() {
//   return mtkMapInstance;
// }


// export function destroyMTKMap() {
//   if (mtkMapInstance) {
//     console.log("Distrug MTK map...");
//     mtkMapInstance.remove();
//     mtkMapInstance = null;
//     console.log("Distrug MTK map...", mtkMapInstance);
//   }
// }


//varianta cu layer SF
let mtkMapInstance = null;

/**
 * Inițializează harta MTK.
 *
 * @param {HTMLElement} container
 * @param {[number, number]} center - [lng, lat]
 * @param {number} zoom
 * @param {{
 *   transformRequest?: Function,
 *   styleUrl?: string,
 *   preserveDrawingBuffer?: boolean,
 *   antialias?: boolean
 * }} opts
 */

// class SFControl {
//   constructor(options = {}) {
//     this.options = options;
//     this._map = null;
//     this._container = null;
//     this._button = null;
//     this._active = false;
//   }

//   onAdd(map) {
//     this._map = map;

//     this._container = document.createElement("div");
//     this._container.className =
//       "maplibregl-ctrl maplibregl-ctrl-group sf-control";

//     this._button = document.createElement("button");
//     this._button.type = "button";
//     this._button.title = "SF";

//     const img = document.createElement("img");

//     img.src =
//       this.options.image ||
//       "/img/sf-layer.png";

//     img.alt = "SF";
//     img.className = "sf-control-image";

//     this._button.appendChild(img);

//     this._button.addEventListener(
//       "click",
//       this._onClick
//     );

//     this._container.appendChild(this._button);

//     return this._container;
//   }

//   _onClick = () => {
//     this._active = !this._active;

//     this._button.classList.toggle(
//       "active",
//       this._active
//     );

//     this.options.onToggle?.(this._active);
//   };

//   onRemove() {
//     this._button?.removeEventListener(
//       "click",
//       this._onClick
//     );

//     this._container?.remove();

//     this._map = null;
//   }
// }
export function initMTKMap(container, center, zoom, opts = {}) {
  const MTK = window.MTK;

  if (!MTK) {
    console.error("[MTK] MTK not available");
    return null;
  }

  if (!container) {
    console.error("[MTK] Map container missing");
    return null;
  }

  if (!Array.isArray(center) || center.length !== 2) {
    console.error("[MTK] Invalid center:", center);
    return null;
  }

  if (mtkMapInstance) {
    console.warn("[MTK] Map already initialized");
    return mtkMapInstance;
  }

  MTK.init({
    api_key: "f713e5ae59c5d92064ce08407c48072b",
  });

   const styleUrl =
    opts.styleUrl ||
    "https://styles.maptoolkit.net/maptoolkit/maptoolkit.summer.json";

  console.log("[MTK INIT] STYLE FOLOSIT:", styleUrl);

  MTK.createMap(
    container,
    {
      map: {
        style:styleUrl,
        // mapType: "toursprung-terrain",

        location: {
          center,
          zoom,
          pitch: 0,
          bearing: 0,
        },

        controls: [
          [
            new MTK.Map3DControl({
              showCompass: 1,
              showPitch: 1,
            }),
            "bottom-right",
          ],

          [
            new MTK.StyleControl(["terrain"]),
            "top-right",
          ],

          [
            new MTK.WeatherControl({
              mode: "null",
            }),
            "top-right",
          ],
        ],
      },
    },

    map => {
      if (!map) {
        console.error("[MTK] createMap returned no map");
        return;
      }

      mtkMapInstance = map;
      window.mtkMap = map;

      const gl = map.gl;
      console.log("[MTK INIT] opts.styleUrl =", opts.styleUrl);

      if (!gl) {
        console.error("[MTK] map.gl not available");
        return;
      }

      /*
       * Ordinea este importantă:
       * 1. instalăm transformRequest
       * 2. apoi aplicăm stilul
       *
       * Astfel și resursele cerute de stil pot fi interceptate.
       */
      installTransformRequest(
        gl,
        opts.transformRequest,
      );

      // installCustomStyle(
      //   gl,
      //   opts.styleUrl,
      // );

      installPoiVisibilityHandler(gl);

      installBackgroundHandler(
        gl,
        container,
      );

      try {
        map.enableTerrain?.();
      } catch (error) {
        console.warn(
          "[MTK] Could not enable terrain:",
          error,
        );
      }

      console.log("[MTK] 3D map loaded");
      if (typeof opts.onReady === "function") {
        try {
          console.log("[MTK] Calling onReady callback");
          opts.onReady(map);
        } catch (error) {
          console.error(
            "[MTK] onReady callback failed:",
            error,
          );
        }
      }
    },
  );

  return null;
}

/**
 * Instalează transformRequest pe motorul GL.
 * Este folosit inclusiv pentru transformarea URL-urilor dummy
 * în URL-uri WMTS reale.
 *
 * @param {Object} gl
 * @param {Function|undefined} transformRequest
 */
function installTransformRequest(
  gl,
  transformRequest,
) {
  console.log(
    "[WMTS] setTransformRequest available:",
    typeof gl?.setTransformRequest,
  );

  console.log(
    "[WMTS] transformRequest passed:",
    typeof transformRequest,
  );

  if (typeof transformRequest !== "function") {
    console.warn(
      "[WMTS] No transformRequest function provided",
    );
    return;
  }

  if (typeof gl.setTransformRequest !== "function") {
    console.warn(
      "[WMTS] map.gl.setTransformRequest is not available",
    );
    return;
  }

  gl.setTransformRequest((url, resourceType) => {
    try {
      const transformed = transformRequest(
        url,
        resourceType,
      );

      /*
       * Funcția trebuie să întoarcă:
       * { url: "..." }
       *
       * Dacă nu întoarce nimic, păstrăm URL-ul original.
       */
      if (
        transformed &&
        typeof transformed === "object" &&
        transformed.url
      ) {
        return transformed;
      }

      return { url };
    } catch (error) {
      console.error(
        "[WMTS] transformRequest failed:",
        {
          url,
          resourceType,
          error,
        },
      );

      return { url };
    }
  });
}

/**
 * Aplică stilul personalizat MTK / MapLibre.
 *
//  * @param {Object} gl
//  * @param {string|undefined} styleUrl
//  */
// function installCustomStyle(gl, styleUrl) {
//   const normalizedStyleUrl =
//     typeof styleUrl === "string"
//       ? styleUrl.trim()
//       : "";

//   if (!normalizedStyleUrl) {
//     console.log(
//       "[MTK] No custom style URL provided",
//     );
//     return;
//   }

//   if (typeof gl.setStyle !== "function") {
//     console.warn(
//       "[MTK] map.gl.setStyle is not available",
//     );
//     return;
//   }

//   console.log(
//     "[MTK] Applying style URL:",
//     normalizedStyleUrl,
//   );

//   gl.on?.("error", event => {
//     console.warn(
//       "[MTK style error]",
//       event?.error || event,
//     );
//   });

//   try {
//     gl.setStyle(normalizedStyleUrl);
//   } catch (error) {
//     console.error(
//       "[MTK] Could not apply custom style:",
//       error,
//     );
//   }
// }

/**
 * Ascunde POI-urile din stilul MTK.
 * @param {Object} gl
 */

function installPoiVisibilityHandler(gl) {
  const poiLayersToHide = new Set([
    "poi_label_bank",
    "poi_label_peaks",
    "poi_label_alpine_hut",
    "poi_label_garden",
    "poi_label_pitch",
    "poi_toilet",
    "poi_generator",
    "poi_label_rail_station",
    "poi_label_aerialway_station_icon",
    "poi_label_subway_label",
    "poi_label_3",
    "poi_label_2",
    "poi_label_1",
    "poi_label_mountain_pass",
  ]);

  let isHidingPoiLayers = false;

  const hidePoiLayers = () => {
    if (isHidingPoiLayers) return;

    const style = gl.getStyle?.();
    if (!style?.layers?.length) return;

    isHidingPoiLayers = true;

    try {
      for (const layer of style.layers) {
        if (!poiLayersToHide.has(layer.id)) {
          continue;
        }

        try {
          gl.setLayoutProperty(
            layer.id,
            "visibility",
            "none"
          );
        } catch (error) {
          console.warn(
            `[MTK] Could not hide layer "${layer.id}"`,
            error
          );
        }
      }
    } finally {
      isHidingPoiLayers = false;
    }
  };


  if (gl.isStyleLoaded?.()) {
    hidePoiLayers();
  } else {
    gl.once?.("style.load", hidePoiLayers);
  }


  gl.on?.("styledata", hidePoiLayers);
}
/**
 * Setează fundalul containerului în funcție de pitch.
 *
 * @param {Object} gl
 * @param {HTMLElement} mapContainer
 */
function installBackgroundHandler(
  gl,
  mapContainer,
) {
  if (!mapContainer) {
    return;
  }

  const getGradientForPitch = pitch => {
    if (pitch >= 86) {
      return (
        "linear-gradient(" +
        "to bottom, " +
        "#a3d8fd 0%, " +
        "#b0e2ff 30%, " +
        "#f0f8ff 40%" +
        ")"
      );
    }

    if (pitch >= 77) {
      return (
        "linear-gradient(" +
        "to bottom, " +
        "#a3d8fd 0%, " +
        "#b0e2ff 20%, " +
        "#f0f8ff 30%" +
        ")"
      );
    }

    return (
      "linear-gradient(" +
      "to bottom, " +
      "#d6f0ff 0%, " +
      "#b0e2ff 70%, " +
      "#f0f8ff 100%" +
      ")"
    );
  };

  const updateBackground = () => {
    const pitch = Number(gl.getPitch?.() ?? 0);

    mapContainer.style.background =
      getGradientForPitch(pitch);
  };

  updateBackground();

  /*
   * pitch este suficient.
   * Nu este nevoie să rulăm funcția la fiecare pan pe hartă.
   */
  gl.on?.("pitch", updateBackground);

  /*
   * Fallback pentru implementări care nu emit "pitch".
   */
  gl.on?.("move", updateBackground);
}

/**
 * Returnează instanța MTK curentă.
 */
export function getMTKMap() {
  return mtkMapInstance;
}

/**
 * Distruge harta MTK.
 */
export function destroyMTKMap() {
  if (!mtkMapInstance) {
    return;
  }

  console.log("[MTK] Destroying map");

  try {
    mtkMapInstance.remove?.();
  } catch (error) {
    console.error(
      "[MTK] Could not destroy map:",
      error,
    );
  } finally {
    mtkMapInstance = null;

    if (window.mtkMap) {
      window.mtkMap = null;
    }
  }

  console.log("[MTK] Map destroyed");
}
